import classNames from 'classnames'
import React, { HTMLProps, ReactNode } from 'react'

export interface TabProps extends HTMLProps<HTMLDivElement> {
  children: ReactNode
  className?: string
  selected?: boolean
}

export default function Tab(props: TabProps): JSX.Element {
  const { children, selected, className, ...otherProps } = props
  const containerClassName = classNames('tab', className, { selected })

  return (
    <div className={containerClassName} {...otherProps}>
      <div className="tab__content">{children}</div>
    </div>
  )
}
